// extracted by mini-css-extract-plugin
module.exports = {"slick-slide":"gethelpwith_slick-slide__SnZhL","slick-list":"gethelpwith_slick-list__xgcrY"};